import { createContext, useContext } from 'react';

interface TranslationContextType {
  t: (query: string) => string;
}

const TranslationContext = createContext<TranslationContextType>({
  t: () => {
    return 'no translations';
  },
});

function TranslationProvider(props: any) {
  const dictionary = require('../localization/en.json');

  const t = (query: string) => {
    const queryArr = query.split('.');
    let current = dictionary;
    queryArr.forEach((q) => {
      current = current[q];
    });

    if (current) return current;
    else return `!${query}`;
  };

  return <TranslationContext.Provider value={{ t }} {...props} />;
}

const useTranslation = () => useContext<TranslationContextType>(TranslationContext);

export { TranslationProvider, useTranslation };
